import { Link } from "react-router-dom";
import type { MovieItem } from "@/mocks/movies";

type Props = {
  item: MovieItem;
};

export default function MovieCard({ item }: Props) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-accent-300 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} - 剧情介绍`}
          title={`${item.title} - 邻居的妻子影视大全`}
          className="w-full h-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-900/85 text-background-50 text-[11px] font-medium">
          {item.category}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-accent-500 text-primary-950 text-[11px] font-bold">
          {item.rating.toFixed(1)}
        </span>
        <span className="absolute inset-x-0 bottom-0 px-2 py-1.5 bg-primary-950/80 text-background-100 text-[11px] text-center">
          {item.updateStatus}
        </span>
      </div>
      <div className="p-3">
        <h3 className="font-heading text-sm font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <div className="mt-1.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] text-foreground-500">
          <span>{item.region}</span>
          <span className="text-background-400">·</span>
          <span>{item.year}</span>
          <span className="text-background-400">·</span>
          <span className="text-secondary-700">{item.genre}</span>
        </div>
      </div>
    </Link>
  );
}